import styled, { css } from 'styled-components';
import { UIText } from '@/component-library/UiText';
import {
  Article,
  LOT_THEME,
  ResetLi,
  ResetUl,
  UnstyledButton,
} from '../_Common/lot.common.styles';
import { SimplePrimaryButton } from '../_Common/SimplePrimaryButton';

export const Container = styled(Article)``;
export const ModalContainer = styled(Article)`
  max-width: 876px;
  width: 100%;
  gap: 16px;

  div {
    display: grid;
    gap: 8px;
  }

  h2 {
    font-size: 18px;
    line-height: 28px;
    font-weight: bold;
  }
`;

export const List = styled(ResetUl)`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
  @media screen and (width < ${LOT_THEME.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const ModalList = styled(ResetUl)`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr 1fr;
  position: relative;
  label {
    position: absolute;
  }
  @media screen and (width < ${LOT_THEME.breakpoints.lg}) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (width < ${LOT_THEME.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export { Address } from '../_Common/lot.common.styles';
export const Item = styled.li<{ $disabled?: boolean }>`
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  border: 1px solid ${LOT_THEME.divider};
  padding: 16px;

  display: grid;
  grid-template-columns: 5fr 1fr;
  grid-template-rows: repeat(3, min-content);
  gap: 2px;
  grid-auto-flow: column;
  transition: box-shadow 0.3s ease;

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: ${LOT_THEME.backgroundPrimaryGray};
      p {
        color: ${LOT_THEME.breadcrumb_sale};
      }
    `}

  &:hover {
    box-shadow: none;
  }
  &:active {
    box-shadow: 2px 2px 4px 0 rgba(51, 49, 50, 0.24);
  }
  h3,
  p {
    line-height: 24px;
    text-transform: capitalize;
  }
  &:active > button {
    box-shadow: 2px 2px 4px 0 rgba(51, 49, 50, 0.24);
  }
`;
export const Day = styled(UIText)`
  font-weight: bolder;
  line-height: 24px;
`;

export const CalBtn = styled(UnstyledButton)`
  width: 32px;
  height: 32px;
  justify-self: end;
  align-self: end;
  grid-row: 1 / 4;
  transition: box-shadow 300ms ease-out;
  display: grid;
  place-items: center;

  border-radius: 4px;
  &:hover {
    box-shadow: 2px 2px 4px 0 rgba(51, 49, 50, 0.24) !important;
  }

  &:active {
    box-shadow: inset 1px 1px 3px 0 rgba(51, 49, 50, 0.24) !important;
  }
`;
export const Button = styled(SimplePrimaryButton)`
  width: fit-content;
`;

export const NoAppointments = styled(ResetLi)`
  background-color: ${LOT_THEME.backgroundPrimaryGray} !important;
  color: ${LOT_THEME.breadcrumb_sale};
  font-size: 18px;
  grid-column: span 3;
  display: grid;
  place-items: center;
  height: 80px;
`;

export const HGroup = styled.hgroup`
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: visible;
`;
